import request from '@/utils/request'

// 根据店铺linkid 获取分类和商品
export function listGoodsByShop (linkid) {
  return request({
    url: `/payPage/goodIdList/getAllListNameAndGoodListByShopLinkid/${linkid}`,
    method: 'get'
  })
}

// 根据分类linkid 获取分类和商品
export function listGoodsByCategory (linkid) {
  return request({
    url: `/payPage/goodIdList/getAllListNameAndGoodListByCateLinkid/${linkid}`,
    method: 'get'
  })
}

// 根据商品linkid 获取分类和商品
export function listGoodsByGoods (linkid) {
  return request({
    url: `/payPage/pageInfo/getGoodInfoByLinkid/${linkid}`,
    method: 'get'
  })
}

// 获取所有模板
export function listThemes (type, linkid) {
  return request({
    url: `/paypage/PayThemeList/getTemplateNameByLinkid`,
    method: 'get',
    params: {linkidType: type, linkid: linkid}
  })
}

// 获取商户信息
export function getMerchant (type, linkid) {
  let url = ''
  if (type === 'shop') {
    url = `/payPage/pageInfo/getShopInfoByShopLinkid/${linkid}`
  } else if (type === 'category') {
    url = `/payPage/pageInfo/getShopInfoByCateLinkid/${linkid}`
  } else if (type === 'goods') {
    url = `/payPage/pageInfo/getShopInfoByDetailLinkid/${linkid}`
  }
  return request({
    url: url,
    method: 'get'
  })
}

// 获取商品id
export function getGoods (goodid) {
  return request({
    url: `/payPage/pageInfo/getGoodInfoByGoodid/${goodid}`,
    method: 'get'
  })
}

// 创建订单
export function createOrder (data) {
  return request({
    url: `/payPage/createOrder/addSave`,
    method: 'post',
    data: data
  })
}

// 预支付
export function prePay (orderid) {
  return request({
    url: `/payPage/gateway/getPreparePay`,
    method: 'get',
    params: {orderid: orderid}
  })
}

// 去支付
export function pay (params) {
  return request({
    url: `/payPage/gateway/doPay`,
    method: 'get',
    params: params
  })
}

// 根据关键字查询订单
export function listOrder (kw) {
  return request({
    url: `/index/orderlist/orderQuery`,
    method: 'get',
    params: {kw: kw}
  })
}

// 获取配置
export function getConfig () {
  return request({
    url: `/index/config/getInfo`,
    method: 'get'
  })
}

// 获取优惠券
export function getCoupon (goodid, couponCode) {
  return request({
    url: `/paypage/ajax/getCouponInfo`,
    method: 'get',
    params: {goodid: goodid, coupon_code: couponCode}
  })
}



// WEBPACK FOOTER //
// ./src/api/goods.js